import { Suspense, lazy } from "react";

const DotLottieReact = lazy(() => import("@lottiefiles/dotlottie-react").then((m) => ({ default: m.DotLottieReact })));

const LOTTIE_SRC = "https://lottie.host/6c334d2f-fcb1-4f47-b766-5ef03f5884c8/PMbvu3CtW7.lottie";

export function SubmittingOverlay() {
  return (
    <div className="flex fixed inset-0 z-50 flex-col justify-center items-center backdrop-blur-sm bg-white/80">
      <Suspense fallback={null}>
        <DotLottieReact src={LOTTIE_SRC} loop autoplay className="w-40 h-40" />
      </Suspense>
    </div>
  );
}
